/** API-first rollout: older API deployments reject unknown signup fields. */
export function trialOnboardingContext(): { onboarding?: 'trial-v1' } {
  return process.env.NEXT_PUBLIC_TRIAL_ONBOARDING_ENABLED === 'true'
    ? { onboarding: 'trial-v1' }
    : {};
}

export function validatedTrialCheckoutUrl(destination: string, origin: string): string {
  const url = new URL(destination, origin);
  const hosted = url.protocol === 'https:' && url.hostname === 'checkout.stripe.com' && !url.port;
  const recovery = url.origin === origin && url.pathname === '/onboarding';
  if (url.username || url.password || (!hosted && !recovery))
    throw new Error('Unexpected checkout destination.');
  return url.href;
}

/** Only server-generated Stripe Checkout links or this app's recovery URL may open. */
export function navigateToTrialCheckout(destination: string): void {
  window.location.assign(validatedTrialCheckoutUrl(destination, window.location.origin));
}

/** Billing remains available while the local activation webhook is delayed. */
export function validatedTrialPortalUrl(destination: string): string {
  const url = new URL(destination);
  if (
    url.protocol !== 'https:' ||
    url.hostname !== 'billing.stripe.com' ||
    url.port ||
    url.username ||
    url.password
  )
    throw new Error('Unexpected billing destination.');
  return url.href;
}
export function navigateToTrialPortal(destination: string): void {
  window.location.assign(validatedTrialPortalUrl(destination));
}
